__turbopack_context__.v({
  "root": "sC1AjG_root",
  "tabs": "sC1AjG_tabs",
  "visible": "sC1AjG_visible",
});
